export const ALLOWED_EXTENSIONS = ['docx', 'pdf', 'png']